export default "__VITE_ASSET__D2FuY4m3__"